module.exports = __webpack_public_path__ + "img/web-P4-0-1.4694619d.svg";